module.exports = __webpack_public_path__ + "img/empty_profile.17c35330.png";